const checkDiff = <T>(list: Array<T>) => new Set(list).size !== 1

const fillArray = <T>(value: T, timesToRepeat: number) => Array(timesToRepeat).fill(value)

const sumArray = (accumulator: number, initialValue: number) => accumulator + initialValue

type RemoveEmptyValuesArrayProps = string | number | undefined | null

const removeEmptyValuesArray = (list: Array<RemoveEmptyValuesArrayProps>) =>
  list.filter((value) => value)

const dynamicSort = <T>(property: keyof T) => {
  const sortOrder = 1

  return function (a: T, b: T) {
    const result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}

const removeCodeAndDescriptionDuplicatedItems = (
  items: { Codigo: string; Descricao: string }[],
) => {
  const result = items.filter(
    (item, index, self) =>
      index === self.findIndex((t) => t.Codigo === item.Codigo && t.Descricao === item.Descricao),
  )

  return result
}

type TitleOption = { title: string; value: string }
type LabelOption = { label: string; value: string }
type Options = TitleOption | LabelOption

const isTitleOption = (item: Options): item is TitleOption => 'title' in item

const getKeyByTitleOrLabel = (value: string[] | undefined, options: Options[]) => {
  return options
    .filter((item) => value?.includes(isTitleOption(item) ? item.title : item.label))
    .map((item) => item.value)
}

export {
  checkDiff,
  dynamicSort,
  fillArray,
  getKeyByTitleOrLabel,
  removeCodeAndDescriptionDuplicatedItems,
  removeEmptyValuesArray,
  sumArray,
}
